var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricDoorOpener01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.52,13.31H2.48V2.28h11.03V13.31z M2.98,12.81h10.03V2.78H2.98V12.81z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.34,5.57c0.34-0.05,0.75-0.09,1.2-0.09c0.81,0,1.39,0.19,1.77,0.55C9.7,6.38,9.93,6.89,9.93,7.59 c0,0.71-0.22,1.3-0.63,1.7C8.89,9.7,8.22,9.93,7.37,9.93c-0.4,0-0.74-0.02-1.03-0.05V5.57z M6.9,9.44 c0.14,0.03,0.35,0.03,0.57,0.03c1.21,0,1.86-0.68,1.86-1.86c0.01-1.03-0.58-1.69-1.77-1.69c-0.29,0-0.51,0.03-0.66,0.06V9.44z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricDoorOpener01);
export default __webpack_public_path__ + "static/media/ElectricDoorOpener-01.c6d990dade651d736dd7b46e9a526772.svg";
export { ForwardRef as ReactComponent };